import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('industrie', 'comparateur-energie')!;

export default function IndustrieComparateurEnergiePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/industrie"
        backLabel="Espace industrie"
        duration="3 min"
      >
        <ComparateurFunnel lockedAudience="industrie" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace industrie', url: 'https://solutionecofrance.fr/industrie' },
          { name: 'Comparateur énergie', url: 'https://solutionecofrance.fr/industrie/comparateur-energie' },
        ]}
      />
    </>
  );
}
